(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentDetailController', DocumentDetailController);

    DocumentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Document', 'DocumentVersion', 'DocumentWorkItem', 'DocumentEvent', 'AppAccount'];

    function DocumentDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Document, DocumentVersion, DocumentWorkItem, DocumentEvent, AppAccount) {
        var vm = this;

        vm.document = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentUpdate', function(event, result) {
            vm.document = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
